require('./articleLines.less');
import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');

class ArticleLinesController {
    articles = [];
    selected = [];
    promise;
    headerSelect:boolean = false;
    hiddenOrders = [];
    hiddenLocations = [];

    constructor(private $state, private $stateParams, private $mdDialog, private toastService, private PickStatus, private Picklists){ }

    goBack(){
        window.history.back();
    }

    $onInit(){
        this.getPickStatusOrders();
    }

    getPickStatusOrders() {
        this.promise = this.PickStatus.getPickStatusOrders({shipmentId: this.$stateParams.shipmentId}).$promise.then((results) => {
            this.sortDetails(results);
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    assignSelectedToUser (ev) {
        this.$mdDialog.show({
            controller: 'dialogSelectUserController',
            template: require("./selectUserDialog/selectUserDialog.html"),
            parent: angular.element(document.body),
            locals: {
                editMode: false
            },
            targetEvent: ev
        }).then((msg) => {
            if(msg.success){
                let payload = {};
                if(msg && msg.id && msg.id.toString()){
                    payload["assignTo"] = msg.id.toString();
                }
                payload["lines"] = this.selected.map(x => {
                    return x.uniqueId;
                });
                this.Picklists.postPicklists({shipmentId: this.$stateParams.shipmentId}, payload).$promise.then(() => {
                    this.selected = [];
                    this.getPickStatusOrders();
                }, (error) => {
                    this.toastService.parseError(error);
                    this.getPickStatusOrders();
                })
            }
        });
    }

    changeUser (ev, line){
        this.$mdDialog.show({
            controller: 'dialogSelectUserController',
            template: require("./selectUserDialog/selectUserDialog.html"),
            parent: angular.element(document.body),
            locals: {
                editMode: true
            },
            targetEvent: ev
        }).then((msg) => {
            if(msg.success){
                let payload = {};
                if(msg && msg.id && msg.id.toString()){
                    payload["assignTo"] = msg.id.toString();
                }
                this.Picklists.putPicklist({picklistId: line.picklistNo}, payload).$promise.then(() => {
                    this.getPickStatusOrders();
                }, (error) => {
                    this.toastService.parseError(error);
                })
            }
        });
    }

    allCheckboxChanged(){
        if(this.headerSelect){
            this.selected = [];
            this.articles.forEach((article) => {
                article.checkedState = true;
                if(article.type === 'line' && !article.picklistNo && !article.finished){
                    this.selected.push(article);
                }
            });
        }else{
            this.selected = [];
            this.articles.forEach((article) => {
                article.checkedState = false;
            })
        }
    }

    checkboxChanged(row){
        if(row.checkedState){
            this.handleRowSelected(row);
        }else{
            this.handleRowDeselected(row);
        }
        this.checkStateOfSubheadingBox(row);
        this.checkStateOfHeadingBox(row);
        this.checkStateOfLocationHeadingBox(row);
    }

    subheadingCheckboxChanged(row){
        this.handleClickedHeading(row);
        this.checkStateOfHeadingBox(row);
    }

    subheadingLocationCheckboxChanged(row) {
        this.handleClickedLocationHeading(row);
        this.checkStateOfSubheadingBox(row);
        this.checkStateOfHeadingBox(row);
    }

    checkStateOfHeadingBox(row){
        this.headerSelect = (this.articles.findIndex((article) => {
            if(article.type === 'heading'){
                return article.checkedState === false;
            }
        }) < 0);
    }

    checkStateOfSubheadingBox(row){
        let activeHeading = this.articles[this.articles.findIndex((article) => {
            if(article.type === 'heading'){
                return article.orderNo === row.orderNo;
            }
        })];
        activeHeading.checkedState = (this.articles.findIndex((article) => {
            if(article.type === 'line' && article.orderNo === row.orderNo && !article.picklistNo && !article.finished){
                return article.checkedState === false;
            }
        }) < 0);
    }

    checkStateOfLocationHeadingBox(row){
        let activeLocationHeading = this.articles[this.articles.findIndex((article) => {
            if(article.type === 'location-heading'){
                return article.orderNo === row.orderNo && article.location === row.location;
            }
        })];
        activeLocationHeading.checkedState = (this.articles.findIndex((article) => {
            if(article.type === 'line'
                && article.orderNo === row.orderNo
                && article.location === row.location
                && !article.picklistNo
                && !article.finished){
                return article.checkedState === false;
            }
        }) < 0);

    }

    handleRowSelected(row){
        if(!(this.selected.some((selectedRow) => {
            return selectedRow.uniqueId === row.uniqueId
        }))){
            this.selected.push(row);
        }
    }

    handleRowDeselected(row){
        const ind = this.selected.findIndex((selectedRow) => {
            return selectedRow.uniqueId === row.uniqueId;
        });
        if(ind !== -1){
            this.selected.splice(ind, 1);
        }
    }

    handleClickedHeading(heading){
        this.articles.forEach((article) => {
            if(article.orderNo === heading.orderNo && article.type === 'line' && !article.picklistNo && !article.finished){
                article.checkedState = heading.checkedState;
                if(article.checkedState){
                    if(!(this.selected.some((selectedRow) => {
                        return selectedRow.uniqueId === article.uniqueId
                    }))){
                        this.selected.push(article);
                    }
                }else{
                    const ind = this.selected.findIndex((selectedRow) => {
                        return selectedRow.uniqueId === article.uniqueId;
                    });
                    if(ind !== -1){
                        this.selected.splice(ind, 1);
                    }
                }
            } else if (article.orderNo === heading.orderNo && article.type === 'location-heading') {
                article.checkedState = heading.checkedState;
            }
        })
    }

    handleClickedLocationHeading(heading) {
        this.articles.forEach((article) => {
            if(article.orderNo === heading.orderNo && article.location === heading.location && article.type === 'line' && !article.picklistNo && !article.finished){
                article.checkedState = heading.checkedState;
                if(article.checkedState){
                    if(!(this.selected.some((selectedRow) => {
                        return selectedRow.uniqueId === article.uniqueId
                    }))){
                        this.selected.push(article);
                    }
                }else{
                    const ind = this.selected.findIndex((selectedRow) => {
                        return selectedRow.uniqueId === article.uniqueId;
                    });
                    if(ind !== -1){
                        this.selected.splice(ind, 1);
                    }
                }
            }
        })

    }

    sortDetails(details){
        this.articles = [];
        this.headerSelect = false;
        // API sorts like below statement.
        // details = _.orderBy(details, ['orderTypeName', 'orderNo', 'location'], ['desc', 'desc', 'desc']);
        let orderNo = "Not relevant, since it won't match the first check and get overwritten";
        let locationName = "Not relevant, since it won't match the first check and get overwritten aswell.";
        details.forEach((order) => {
            const checkBox = this.checkForPicklistNoOnOrder(details, order.orderNo);
            if(orderNo !== order.orderNo){
                locationName = "Resetting location name for new OrderNo";
                orderNo = order.orderNo;
                this.articles.push({
                    type: 'heading',
                    checkedState: !checkBox,
                    name: order.orderTypeName + " " + order.orderNo,
                    orderNo: order.orderNo,
                    showCheckbox: checkBox,
                    finished: order.finished
                });
            }

            if(locationName !== order.location) {
                const checkBoxLocation = this.checkForPicklistNoOnLocation(details, order.location, order.orderNo);
                locationName = order.location;
                this.articles.push({
                    type: 'location-heading',
                    checkedState: !checkBoxLocation,
                    location: order.location,
                    name: order.storageTypeName,
                    orderNo: order.orderNo,
                    showCheckbox: checkBoxLocation,
                    finished: order.finished
                })
            }

            let progress = order.finished ? 100 : (order.qtyPicked / order.qtyOrdered)*100;
            if(isNaN(progress)){
                progress = 0;
            }
            order['progress'] = progress;
            order['type'] = 'line';
            order['checkedState'] = !checkBox;
            this.articles.push(order);
        });
    }

    checkForPicklistNoOnOrder(orders, orderNo){
        return (orders.some((order) => {
            if(order.orderNo === orderNo) {
                return !order.picklistNo && !order.finished;
            }
        }));
    }

    checkForPicklistNoOnLocation(orders, location, orderNo) {
        return (orders.some((order) => {
            if(order.location === location && order.orderNo === orderNo) {
                return !order.picklistNo && !order.finished;
            }
        }));
    }


    shouldLineBeDisplayed(line) {
        if(line.type === 'heading'){
            return true;
        } else if(line.type === 'location-heading') {
            return !this.isOrderHidden(line.orderNo);
        } else {
            return !this.isOrderHidden(line.orderNo) && !this.isLocationHiddenOnOrder(line.orderNo, line.location);
        }
    }

    hideOrder(item) {
        let orderIndex = this.hiddenOrders.findIndex((order) => {
            return order === item.orderNo;
        });
        if(orderIndex !== -1) {
            this.hiddenOrders.splice(orderIndex, 1);
        } else {
            this.hiddenOrders.push(item.orderNo);
        }
    }

    hideLocation(item){
        let orderIndex = this.hiddenLocations.findIndex((order) => {
            return order.orderNo === item.orderNo && item.location === order.location;
        });
        if(orderIndex !== -1) {
            this.hiddenLocations.splice(orderIndex, 1);
        } else {
            this.hiddenLocations.push({orderNo: item.orderNo, location: item.location});
        }
    }

    isOrderHidden (orderNo) {
        return this.hiddenOrders.some((order) => {
            return orderNo === order;
        });
    }

    isLocationHiddenOnOrder(orderNo, location) {
        return this.hiddenLocations.some((order) => {
            return orderNo === order.orderNo && location === order.location;
        });
    }
}

class ArticleLinesOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcArticleLinesController";
    public template: any = require('./articleLines.html');

}

rkcApp.controller("rkcArticleLinesController", ['$state', '$stateParams', '$mdDialog', 'toastService', 'PickStatus', 'Picklists', function($state, $stateParams, $mdDialog, toastService, PickStatus, Picklists){
    return new ArticleLinesController($state, $stateParams, $mdDialog, toastService, PickStatus, Picklists);
}])
    .component("rkcArticleLines", new ArticleLinesOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distribution/articleLines/articleLines.ts
 **/